import React from 'react';
import Select from 'react-select';

import Checkbox from '../../checkbox/Checkbox';
// import LabelCheckbox from '../../checkbox/LabelCheckbox';
import LabelNameChangeModal from '../../modal/LabelNameChangeModal';

import './LabelInformation.css';

const LabelInformation = (props) => {
  return (
    <div id="labelInformation">
      <div id="labelTitBtn">
        {props.selectedLabelData.labelID == -1 ? <div id="labelTit">{`그룹 정보 확인 (그룹을 선택하세요)`}</div>:
          <>
            <div>
              <div id="labelTit">{`그룹 정보 확인 (${props.selectedLabelData.labelName})`}</div>
              {props.selectedLabelData.labelID === "null" ? <>&nbsp;</>
              : <>
                  <a className="button purple_line" style={{marginLeft:"7px"}} onClick={()=>props.handleNameChangeShow()}>그룹 명 수정</a>
                  <a className="button purple_line" style={{marginLeft:"7px"}} onClick={()=>props.handleRemoveLabel()}>그룹 전체 삭제</a>
                  <LabelNameChangeModal selectedLabelName={props.selectedLabelData.labelName} handleChangeLabelNameInput={props.handleChangeLabelNameInput} handleNameChangeClose={props.handleNameChangeClose} nameChangeShow={props.nameChangeShow} changeLabelName={props.changeLabelName}
                    handleChangeLabelName={props.handleChangeLabelName}/>
                </>}
            </div>
            <div>
              {/* <a className="button grayLine" style={{float:"left", marginRight:"10px"}} onClick={()=>props.handleAllSelect()}>전체 선택</a>
              <a className="button grayLine" style={{float:"left", marginRight:"10px"}} onClick={()=>props.handleAllDeSelect()}>전체 해제</a>           */}
              <div className="labelGroupSelect">
                <Select placeholder="이동할 그룹을 선택하세요" isClearable={true} isSearchable={true}
                  options={props.targetLabelSelectOption}
                  styles={{
                    container: base => ({
                      ...base,
                      width: "300px"
                    }),
                    option: base => ({
                      ...base,
                      textAlign: "left"
                    })
                  }}
                  onChange={(e) => {
                    props.selectTargetLabel(e);
                  }} />
              </div>
              <div id="labelManageBtn">
                <a className="button purple_line" style={{marginRight:"10px"}} onClick={()=>props.handleMoveItem()}>선택 항목 이동</a>
                <a className="button purple_line" style={{marginRight:"10px"}} onClick={()=>props.handleRemoveItem()}>선택 항목 삭제</a>
              </div>
            </div>
          </>
        }
      </div>
      <div className="buzzLabel">
        <div className="buzzLabelContainer">
          <div className="buzzLabelType">
            {`검색어 (${props.selectedLabelData.queryItem.length})`}
          </div>
          <div className="buzzLabelItem">
            {props.selectedLabelData.queryItem.map((item, index) => {
              return(
                <div>
                  <Checkbox ref={el=>(props.myRef.current[index]=el)} className="list-checkbox" checked={item.checked} id={`query-checkbox-${item.queryID}-${index}`} handleCheckBox={props.handleCheckBox} />
                  {`${item.name}`}
                </div>
              )
            })}
          </div>
        </div>
        <div className="buzzLabelContainer">
          <div className="buzzLabelType">
            {`리포트 (${props.selectedLabelData.reportItem.length})`}
          </div>
          <div className="buzzLabelItem">
            {props.selectedLabelData.reportItem.map((item,index) => {
              return(
                <div>
                  <Checkbox className="list-checkbox" checked={item.checked} id={`report-checkbox-${item.reportID}-${index}`} handleCheckBox={props.handleCheckBox} />
                  {`${item.name}`}
                </div>
              )
            })}
          </div>
        </div>
        <div className="buzzLabelContainer">
          <div className="buzzLabelType">
            {`스냅샷 (${props.selectedLabelData.snapshotItem.length})`}
          </div>
          <div className="buzzLabelItem">
            {props.selectedLabelData.snapshotItem.map((item,index) => {
              return(
                <div>
                  <Checkbox className="list-checkbox" checked={item.checked} id={`snapshot-checkbox-${item.snapshotID}-${index}`} handleCheckBox={props.handleCheckBox} />
                  {`${item.name}`}
                </div>
              )
            })}
          </div>
        </div>
        {/* <div className="buzzLabelContainer">
          <div className="buzzLabelType">
            {`커스텀 리포트 (${props.selectedLabelData.customItem.length})`}
          </div>
          <div className="buzzLabelItem">
            {props.selectedLabelData.customItem.map((item, index) => {
              return(
                <div>
                  <Checkbox className="list-checkbox" checked={item.checked} id={`custom-checkbox-${item.customID}-${index}`} handleCheckBox={props.handleCheckBox} />
                  {`${item.name}`}
                </div>
              )
            })}
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default LabelInformation;